<template>
  <div class="search">
    <custom-plane
      title="车辆精确查询"
      :iconImg="require('@/assets/compImg/parking/parking.png')"
    >
      <div class="search_data">
        <div class="car_query">车辆查询</div>
        <div class="inpt">
          <el-input
            placeholder="请输入车牌号"
            v-model="inputData"
            @blur="inputData = $event.target.value.trim()"
            @keyup.enter.native="search"
            clearable
          />
          <div class="btn" @click="search">搜索</div>
        </div>
      </div>
    </custom-plane>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inputData: "",
    };
  },
  methods: {
    search() {
        this.$emit("sendSearch", this.inputData);
    },
  },
};
</script>
<style lang="scss" scoped>
.search {
  width: 416px;
  height: 127px;
  .search_data {
    padding: 26.5px 20px;
    display: flex;
    justify-content: space-between;
    .car_query {
      width: 72px;
      height: 27px;
      line-height: 27px;
      font-size: 18px;
    }
    .inpt {
      pointer-events: all;
      display: flex;
      .el-input {
        width: 189px;
        height: 32px;
      }
      ::v-deep .el-input__suffix{
        display: flex;
        justify-content: center;
        align-items: center;
      }
      ::v-deep .el-input__inner {
        padding: 0 12px;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        color: #fff;
        border: 1px solid rgba(255, 255, 255, 0.1);
      }
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px 12px;
        width: 52px;
        height: 32px;
        background: rgba(255, 255, 255, 0.2);
        font-size: 14px;
        cursor: default;
      }
    }
  }
}
</style>